import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Trash2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function LogsTab() {
  const [logs, setLogs] = useState(null);
  const { user } = useAuth();
  const canDelete = ["admin", "supervisor"].includes(user?.role);

  const load = async () => setLogs((await api.get("/irrigation/logs")).data);
  useEffect(() => { load(); }, []);
  if (!logs) return <div className="p-6 font-bold uppercase text-sm">Loading logs…</div>;

  const remove = async (l) => {
    if (!window.confirm("Delete this log?")) return;
    await api.delete(`/irrigation/logs/${l.id}`);
    await load();
  };

  return (
    <div className="bg-white border border-stone-200 overflow-x-auto" data-testid="irr-logs-tab">
      <table className="w-full text-sm min-w-[760px]">
        <thead>
          <tr className="bg-[#1F3D34] text-white text-left text-[10px] uppercase">
            <th className="p-3">Date</th><th className="p-3">Block</th><th className="p-3 text-right">Hours</th>
            <th className="p-3 text-right">Gallons</th><th className="p-3">Logged By</th><th className="p-3">Note</th>{canDelete && <th className="p-3"></th>}
          </tr>
        </thead>
        <tbody>
          {logs.map((l) => (
            <tr key={l.id} data-testid={`log-row-${l.id}`} className="border-t border-stone-200">
              <td className="p-3 font-mono">{l.date}</td>
              <td className="p-3 font-bold">{l.block_label}<span className="font-normal text-xs text-stone-500"> · {l.ranch_number} {l.vineyard_name}</span></td>
              <td className="p-3 text-right font-bold">{l.hours}</td>
              <td className="p-3 text-right">{l.gallons != null ? Number(l.gallons).toLocaleString() : "—"}</td>
              <td className="p-3">{l.logged_by}</td>
              <td className="p-3 text-xs text-stone-500">{l.note || ""}</td>
              {canDelete && <td className="p-2"><button data-testid={`log-delete-${l.id}`} onClick={() => remove(l)} className="h-9 w-9 border border-stone-300 text-red-700 inline-flex items-center justify-center"><Trash2 size={12} /></button></td>}
            </tr>
          ))}
          {logs.length === 0 && <tr><td colSpan={7} className="p-8 text-center text-stone-400 font-bold uppercase text-sm">No irrigation logged yet</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
